import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface ConnectedProps {
    groupName?: string;
}

type Props = ConnectedProps;

export class SharedEventGroupNameHeader extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { groupName } = this.props;
        if (!groupName) return null;
        return (
            <Header sub className="shared-event-sub-header">
                Group
            </Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    groupName: makeSelectSharedEventValue('groupName')
});

export default connect(mapStateToProps)(SharedEventGroupNameHeader);
